module.exports = __webpack_public_path__ + "img/symbol_6.a6989c9b.png";